import { Tabs as BsTabs, Tab as BsTab } from 'react-bootstrap5';

export const Tabs = BsTabs;
export const Tab = BsTab;
